import { useEffect, useState } from 'react';
import axios from 'axios';
import { ContactVerificationConfirmRequest, ContactVerificationConfirmResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

type VerificationType = 'email' | 'phone';

export default function useConfirmContactVerification(verificationType: VerificationType) {
  const source = axios.CancelToken.source();
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  const confirmVerification = async (
    requestParams: ContactVerificationConfirmRequest,
  ): Promise<ContactVerificationConfirmResponse> => {
    setConfirming(true);
    try {
      const res =
        verificationType === 'phone'
          ? await api.confirmPhoneVerification(requestParams, source)
          : await api.confirmEmailVerification(requestParams, source);

      return res;
    } finally {
      setConfirming(false);
    }
  };

  return {
    confirming,
    confirmVerification,
  };
}
